/**
 * Purchase invoice (bill) document viewer — a thin wrapper over the shared
 * DocumentPrintPage with the bill (vendor/supplier-facing) configuration.
 */
import { BILL_DOC_CONFIG } from './docPrintConfigs.js';
import { DocumentPrintPage } from './DocumentPrintPage.js';

export function BillPrintPage(): JSX.Element {
  return <DocumentPrintPage config={BILL_DOC_CONFIG} />;
}
